import IconComponent from "icons/IconComponent";

import MenuIcon from "./menuIcon.svg";

export default (MenuIcon as any) as IconComponent;
